<template>
	<div>
		<ParamResult ref="paramResult"></ParamResult>
		<div
			v-if="terminal === 0"
			class="panel bgPanel ml205x mr205x pt2x cb pr2x pl2x pb2x mr205x ml205x"
			fillHeight="lastHeight,-space"
		>
			<div class="filter ml205x mr205x">
				<div class="tableSys mb2x vaM_E">
					<div class="dpIB_E vaM_E">
						<Select
							:name="'instructionsStatus'"
							:class="{ sizeS: true }"
							:list="instructionsStatusList"
							:key-map="{ text: 'name', value: 'value' }"
							@Click="instructionsStatusSelect"
						></Select>
					</div>
				</div>
			</div>
			<div class="tableScope bgPanel boxR ml205x mr205x">
				<div
					class="table tra-fast posR"
					fillHeight="lastHeight,-.tableBatch,-space"
				>
					<Loading ref="loading"></Loading>
					<div
						v-show="list.length > 0"
						id="readerRecordList"
						class="cb"
					>
						<div
							class="scrollHide tra-fast fL"
							:style="{ width: '16em' }"
							scrollFloatX="false"
							fillHeight="lastHeight,-.tableBatch,-space"
						>
							<div
								class="tableSys head noSelect b cField bdLight-bottom tra-fast_E"
								scrollFloatY="false"
							>
								<div
									class="pl2x-imp sequence"
									:class="{ cMain: orderProperty == 3 }"
									:title="
										getLanguageStr(
											'word1776',
											'指令发送时间'
										)
									"
									@click="order(2)"
								>
									<span>{{
										getLanguageStr(
											"word1776",
											"指令发送时间"
										)
									}}</span>
									<span
										:sequence="
											orderProperty == 2 ? orderedsc : ''
										"
									></span>
								</div>
							</div>
							<div
								class="fixedScrollBar scrollY tra-fast"
								fillHeight="lastHeight,-.tableBatch,-space"
								scroll="{'group':'a'}"
							>
								<table>
									<thead class="head-token">
										<tr>
											<th></th>
										</tr>
									</thead>
									<tbody
										class="bdLight-bottom_E emptyToken_EE textCut_EE"
									>
										<tr
											v-for="(record, index) in list"
											:key="index"
										>
											<td
												class="pl2x-imp"
												:title="
													record.createTime
														? timeFormat(
																record.createTime /
																	1000,
																'system',
																'%Y/%m/%d %H:%M:%S UTC'
														  )
														: '--'
												"
											>
												<div>
													{{
														record.createTime
															? timeFormat(
																	record.createTime /
																		1000,
																	"system",
																	"%H:%M:%S"
															  )
															: "--"
													}}
												</div>
												<div class="cSub">
													{{
														record.createTime
															? timeFormat(
																	record.createTime /
																		1000,
																	"system",
																	"%Y/%m/%d UTC"
															  )
															: "--"
													}}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div scroll="{'axis':'x'}">
							<div
								class="tableSys head noSelect b cField bdLight-bottom"
								:style="{
									'min-width':
										stage.setting.system
											.autoColumnWidth[0] *
											column.length +
										stage.setting.system.autoColumnWidth[1]
								}"
								scrollFloatY="false"
							>
								<div :title="$t('word1501', ['指令名称'])">
									{{ $t("word1501", ["指令名称"]) }}
								</div>
								<div
									:title="
										getLanguageStr(
											'device_management69',
											'指令类型'
										)
									"
								>
									{{
										getLanguageStr(
											"device_management69",
											"指令类型"
										)
									}}
								</div>
								<div :title="$t('word1502', ['输入项'])">
									{{ $t("word1502", ["输入项"]) }}
								</div>
								<div :title="$t('device254', ['返回结果'])">
									{{ $t("device254", ["返回结果"]) }}
								</div>
								<div
									:title="
										getLanguageStr('word1777', '指令状态')
									"
								>
									{{ getLanguageStr("word1777", "指令状态") }}
								</div>
								<div
									style="overflow: inherit"
									:title="$t('task39', ['失败原因'])"
								>
									{{ $t("task39", ["失败原因"])
									}}<Help
										:code="'reasonFailureDetail'"
										:btn-close="false"
										class="ml05x"
									></Help>
								</div>
								<div :title="$t('word788', ['操作人'])">
									{{ $t("word788", ["操作人"]) }}
								</div>
								<div
									:class="{ cMain: orderProperty == 3 }"
									class="sequence"
									:title="
										getLanguageStr('plant56', '反馈时间')
									"
									@click="order(3)"
								>
									<span>{{
										getLanguageStr("plant56", "反馈时间")
									}}</span>
									<span
										:sequence="
											orderProperty == 3 ? orderedsc : ''
										"
									></span>
								</div>
							</div>
							<div
								class="fixedScrollBar scrollY tra-fast"
								fillHeight="lastHeight,-.tableBatch,-space"
								scroll="{'group':'a'}"
							>
								<table
									:style="{
										'min-width':
											stage.setting.system
												.autoColumnWidth[0] *
												column.length +
											stage.setting.system
												.autoColumnWidth[1]
									}"
								>
									<thead class="head-token">
										<tr>
											<th></th>
											<th></th>
											<th></th>
											<th></th>
											<th></th>
											<th></th>
											<th></th>
										</tr>
									</thead>
									<tbody
										class="bdLight-bottom_E emptyToken_EE textCut_EE"
									>
										<tr
											v-for="(record, index) in list"
											:key="index"
										>
											<td :title="getOrderName(record)">
												{{ getOrderName(record) }}
											</td>
											<td
												:title="
													record.operationTypeName ||
														'--'
												"
											>
												{{
													record.operationTypeName ||
														"--"
												}}
											</td>
											<td
												v-if="
													record.operationType !== 5
												"
												:title="getEntries(record).text"
												:class="
													getEntries(record).className
												"
												@click="
													openResult(
														getEntries(record)
															.params,
														record
													)
												"
											>
												{{ getEntries(record).text }}
											</td>
											<td v-else>
												<a
													class="cMain"
													@click="moreInput(record)"
													>{{
														record.extendWeb &&
														JSON.parse(
															record.extendWeb
														).inputParam &&
														Object.keys(
															JSON.parse(
																record.extendWeb
															).inputParam
														).length > 0
															? getLanguageStr(
																	"device_management60",
																	"查看更多"
															  )
															: "--"
													}}</a
												>
											</td>
											<td
												v-if="
													record.operationType !==
														4 &&
														record.operationType !==
															5
												"
												:title="getResult(record).text"
												:class="
													getResult(record).className
												"
												@click="
													openResult(
														getResult(record)
															.params,
														record
													)
												"
											>
												{{ getResult(record).text }}
											</td>
											<td v-else>
												<a
													class="cMain"
													@click="moreResult(record)"
													>{{
														record.analysisResult
															? getLanguageStr(
																	"device_management60",
																	"查看更多"
															  )
															: "--"
													}}</a
												>
											</td>
											<td
												:title="
													record.status
														? getTypeText(
																record.status,
																'deviceOrderStatus'
														  )
														: '--'
												"
											>
												{{
													record.status
														? getTypeText(
																record.status,
																"deviceOrderStatus"
														  )
														: "--"
												}}
											</td>
											<td
												:title="
													record.error
														? getTypeText(
																record.error,
																'errorReason'
														  )
														: '--'
												"
											>
												{{
													record.error
														? getTypeText(
																record.error,
																"errorReason"
														  )
														: "--"
												}}
											</td>
											<td
												:title="
													record.createByName || '--'
												"
											>
												{{
													record.createByName || "--"
												}}
											</td>
											<td
												:title="
													record.updateTime
														? timeFormat(
																record.updateTime /
																	1000,
																'system',
																'%Y/%m/%d %H:%M:%S UTC'
														  )
														: '--'
												"
											>
												<div>
													{{
														record.updateTime
															? timeFormat(
																	record.updateTime /
																		1000,
																	"system",
																	"%H:%M:%S"
															  )
															: "--"
													}}
												</div>
												<div class="cSub">
													{{
														record.updateTime
															? timeFormat(
																	record.updateTime /
																		1000,
																	"system",
																	"%Y/%m/%d UTC"
															  )
															: "--"
													}}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<!--<div class="scrollHide tra-fast fL"
					:style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					scrollFloatX="false" fillHeight="lastHeight,-.tableBatch">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<div class="pl2x-imp sequence" :class="{cMain:orderProperty==3}" :title="getLanguageStr('word1776','指令发送时间')" @click="order(2)">
							<span>{{getLanguageStr('word1776','指令发送时间')}}</span>
							<span :sequence="orderProperty==2 ? orderDirection : ''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.tableBatch" scroll="{'group':'a'}">
						<table>
							<thead class="head-token">
								<tr>
									<th></th>
								</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
								<tr v-for="(record,index) in list" :key="index" @click.stop="view()">
									<td class="pl2x-imp" :title="record.createTime?timeFormat(record.createTime/1000,'inc','%Y/%m/%d %H:%M:%S'):'--'">
										<div>{{record.createTime?timeFormat(record.createTime/1000,'inc','%H:%M:%S'):'--'}}</div>
										<div class="cSub">{{record.createTime?timeFormat(record.createTime/1000,'inc','%Y/%m/%d'):'--'}}</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						scrollFloatY="false">
												<div :title="$t('word1501',['指令名称'])">{{$t('word1501',['指令名称'])}}</div>
						<div :title="getLanguageStr('device_management69','指令类型')">{{getLanguageStr('device_management69','指令类型')}}</div>
						<div :title="$t('word1502',['输入项'])">{{$t('word1502',['输入项'])}}</div>
						<div :title="getLanguageStr('word1777','指令状态')">{{getLanguageStr('word1777','指令状态')}}</div>
						<div :title="$t('word788',['操作人'])">{{$t('word788',['操作人'])}}</div>
						<div :class="{cMain:orderProperty==3}" class="sequence" :title="getLanguageStr('plant56','反馈时间')" @click="order(3)">
							<span>{{getLanguageStr('plant56','反馈时间')}}</span>
							<span :sequence="orderProperty==3 ? orderDirection : ''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.tableBatch" scroll="{'group':'a'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<thead class="head-token">
								<tr>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
								</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
								<tr v-for="(record,index) in list" :key="index">
																	<td>{{record.orderName || '--'}}</td>
									<td>{{record.operationTypeName || '--'}}</td>
									<td>{{record.inputParam || '--'}}</td>
									<td>{{record.status?getTypeText(record.status,'instructionsStatus'):'--'}}</td>
									<td>{{record.createByName || '--'}}</td>
									<td :title="record.updateTime?timeFormat(record.updateTime/1000,'inc','%Y/%m/%d %H:%M:%S'):'--'">
										<div>{{record.updateTime?timeFormat(record.updateTime/1000,'inc','%H:%M:%S'):'--'}}</div>
										<div class="cSub">{{record.updateTime?timeFormat(record.updateTime/1000,'inc','%Y/%m/%d'):'--'}}</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>-->
					</div>
					<no-result v-show="list.length == 0"></no-result>
				</div>
				<div
					class="tableBatch bgContent cSub tra-fast boxR-bottom"
					:class="{ disable: !list.length }"
				>
					<Pagination
						class="ml2x"
						:pagination="pagination"
						:get-list="_getList"
					></Pagination>
				</div>
			</div>
		</div>
		<!-- 移动端显示 -->
		<div v-if="terminal === 1" class="mobile">
			<!-- -->
			<div fillHeight="lastHeight" style="overflow: auto">
				<van-pull-refresh
					v-model="refreshing"
					:class="{ noDataList: !list || list.length === 0 }"
					:pulling-text="getLanguageStr('manage230', '下拉可以刷新')"
					:loosing-text="getLanguageStr('manage231', '松开立即刷新')"
					:loading-text="
						getLanguageStr('manage232', '正在刷新数据中...')
					"
					@refresh="onRefresh"
				>
					<van-list
						v-model="loadingMoblie"
						:finished="finished"
						finished-text="End"
						:loading-text="
							getLanguageStr('manage232', '正在刷新数据中...')
						"
						@load="onLoad"
					>
						<div
							v-for="record in list"
							v-show="list.length > 0"
							:key="record.orderId"
							class="panel bgContent mr1x ml2x mt2x pl4x pr4x pt4x"
						>
							<div
								class="bdLight-bottom pb205x mb8xM titleRecord"
							>
								<span
									class="title fsLv3 fsLv5-mobile pt1x pb1x"
									>{{ getOrderName(record) }}</span
								>
								<span
									v-if="
										record.operationType === 1 ||
											record.operationType === 4
									"
									class="redO pl2x pr2x ml1x pt05xx pb05xx typenameOrder fsLv2-mobile"
									>{{
										getLanguageStr(
											"device400",
											"读取指令"
										) || "--"
									}}</span
								>
								<span
									v-if="
										record.operationType === 2 ||
											record.operationType === 5
									"
									class="setO pl2x pr2x ml1x pt05xx pb05xx typenameOrder fsLv2-mobile"
									>{{
										getLanguageStr(
											"device401",
											"设置指令"
										) || "--"
									}}</span
								>
								<span
									v-if="record.operationType === 3"
									class="custO pl2x pr2x ml1x pt05xx pb05xx typenameOrder fsLv2-mobile"
									>{{
										getLanguageStr(
											"device402",
											"自定义指令"
										) || "--"
									}}</span
								>
							</div>
							<div class="mb1x5 fs1x">
								<div class="cSub fsLv4-mobile">
									{{ $t("word1502", ["输入项"]) }}
								</div>
								<div
									v-if="record.operationType !== 5"
									class="ft15 userSelect"
									:class="getEntries(record).className"
									@click="
										openResult(
											getEntries(record).params,
											record
										)
									"
								>
									{{ getEntries(record).text }}
								</div>
								<div v-else>
									<a
										class="cMain ft15 userSelect"
										@click="moreInput(record)"
										>{{
											record.extendWeb &&
											JSON.parse(record.extendWeb)
												.inputParam &&
											Object.keys(
												JSON.parse(record.extendWeb)
													.inputParam
											).length > 0
												? getLanguageStr(
														"device403",
														"点击查看"
												  )
												: "--"
										}}</a
									>
								</div>
							</div>

							<div class="mb1x5 fs1x">
								<div class="cSub">
									{{ $t("device254", ["返回结果"]) }}
								</div>
								<div
									v-if="
										record.operationType !== 4 &&
											record.operationType !== 5
									"
									class="ft15 userSelect"
									:class="getResult(record).className"
									@click="
										openResult(
											getResult(record).params,
											record
										)
									"
								>
									{{ getResult(record).text }}
								</div>
								<div v-else>
									<a
										class="cMain ft15"
										@click="moreResult(record)"
										>{{
											record.analysisResult
												? getLanguageStr(
														"device403",
														"点击查看"
												  )
												: "--"
										}}</a
									>
								</div>
							</div>

							<div class="mb1x5 fs1x">
								<div class="cSub">
									{{ getLanguageStr("word1777", "指令状态") }}
								</div>
								<div
									v-if="record.status === 500"
									class="ft15 userSelect cError"
								>
									{{
										record.status
											? getTypeText(
													record.status,
													"deviceOrderStatus"
											  )
											: "--"
									}}
								</div>
								<div v-else class="ft15 userSelect">
									{{
										record.status
											? getTypeText(
													record.status,
													"deviceOrderStatus"
											  )
											: "--"
									}}
								</div>
							</div>

							<div class="mb1x5 fs1x">
								<div class="cSub">
									{{ $t("word788", ["操作人"]) }}
								</div>
								<div class="ft15 userSelect">
									{{ record.createByName || "--" }}
								</div>
							</div>

							<div class="mb1x5 fs1x">
								<div class="cSub">
									{{
										getLanguageStr(
											"word1776",
											"指令发送时间"
										)
									}}
								</div>
								<div class="ft15 userSelect">
									{{
										record.createTime
											? timeFormat(
													record.createTime / 1000,
													"system",
													"%Y/%m/%d %H:%M:%S UTC"
											  )
											: "--"
									}}
								</div>
							</div>

							<div class="pb5x fs1x">
								<div class="cSub">
									{{ getLanguageStr("plant56", "反馈时间") }}
								</div>
								<div class="ft15 userSelect">
									{{
										record.updateTime
											? timeFormat(
													record.updateTime / 1000,
													"system",
													"%Y/%m/%d %H:%M:%S UTC"
											  )
											: "--"
									}}
								</div>
							</div>

							<div
								v-if="record.status === 500"
								class="mb1x5 fs1x bdLight-top pt1x5 pb5x"
							>
								<div class="cError">
									{{ getLanguageStr("task39", "失败原因") }}：
								</div>
								<div class="ft15 userSelect cSub">
									{{
										record.error
											? getTypeText(
													record.error,
													"errorReasonMobile"
											  )
											: "--"
									}}
								</div>
							</div>
						</div>
						<div
							v-show="list.length == 0"
							class="mt10x nodate pb10x"
						>
							<div>
								<Icon
									name="workorder-template-none"
									:type="'svg'"
								/>
							</div>
							<div class="cSub mt1x">
								{{
									getLanguageStr(
										"device409",
										"暂无任何控制日志"
									)
								}}
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</div>
		</div>
	</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import * as orderConfig from '@/util/deviceOrderConfig'
import Help from '@/components/common/Help.vue'
import { getLanguage } from '@/util/deviceOrderConfig.js'
import * as orderApi from '@/api/device/order.js'
import ParamResult from './ParamResult.vue'

import Select from '@/components/common/ui/Select.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import Pagination from '@/components/common/ui/Pagination.vue'

import Vue from 'vue'
import { List, PullRefresh, Dialog } from 'vant'
Vue.use(List)
Vue.use(PullRefresh)
export default {
  name: 'ReaderRecord',
  components: { Help, ParamResult, Loading, Select, NoResult, Pagination },
  props: {
    deviceId: {
      type: [String, Number],
      default: null
    },
    deviceSn: {
      type: [String, Number],
      default: null
    },
    timezone: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loadingMoblie: false,
      finished: false,
      refreshing: false,
      pagination: {}, // 分页数据
      list: [],
      stage,
      maxPage: 1,
      terminal: 0, // 0为pc，1为移动端
      floatColumn: ['a'],
      column: ['1', '2', '3', '4', '5', '6'],
      orderProperty: 2, // 1:order_id,2:create_time,3:update_time
      orderDirection: 2, // 1:ASC,2:DESC
      orderedsc: 'DESC',
      instructionsStatusList: [
        {
          value: null,
          name: getLanguageStr('cmd19', '全部'),
          def: getLanguageStr('word1777', '指令状态')
        }
      ].concat(lib.getTypeText('', 'deviceOrderStatus', true)), // 指令状态
      instructionsStatusSelected: ''
    }
  },
  methods: {
    timeFormat: lib.timeFormat,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    setMobileChange (val) {
      if (val === 0) {
        this.instructionsStatusSelected = ''
      } else {
        this.instructionsStatusSelected = val
      }

      this.onRefresh()
    },
    jugeEndPage () {
      if (this.pagination.total % this.pagination.request.size === 0) {
        this.maxPage =
					this.pagination.total / this.pagination.request.size
      } else {
        this.maxPage = Math.ceil(
          (this.maxPage =
						this.pagination.total / this.pagination.request.size)
        )
      }
    },
    onRefresh () {
      this.$set(this.pagination.request, 'page', 0)
      this.refreshing = true
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loadingMoblie = true
      this.onLoad()
    },
    onLoad () {
      // console.log("tttt");
      ++this.pagination.request.page
      this._getList().then(() => {
        this.jugeEndPage()
        setTimeout(() => {
          if (this.maxPage <= this.pagination.request.page) { this.finished = true } else this.finished = false
          this.loadingMoblie = false
          this.refreshing = false
          this.$forceUpdate()
        }, 0)
      })
    },
    getEntries (item) {
      if (item.operationType === 2) {
        // 单指令多参数
        let result = orderConfig.analyFunction(item) || {}
        if (result.values && result.values.length > 0) {
          return {
            text: getLanguageStr('device403', '点击查看'),
            className: 'cMain curP',
            params: result.values
          }
        } else {
          return {
            text: this.analysisExt(item),
            className: null
          }
        }
      } else if (item.operationType === 3) {
        return {
          text: this.analysisExt(item),
          className: null
        }
      }
      return {
        text: '--',
        className: null
      }
    },
    getResult (item) {
      // 返回结果
      let result = orderConfig.analyFunction(item) || {}
      if (item.operationType == 1 || item.operationType == 3) {
        // 读取
        if (result.values && result.values.length > 0) {
          return {
            text: getLanguageStr('device403', '点击查看'),
            className: 'cMain curP',
            params: result.values
          }
        }
        return {
          text: result.value,
          className: null
        }
      }
      return {
        text: '--',
        className: null
      }
    },
    openResult (data, record) {
      if (!data) return
      const list = data.map(item => ({
        name: getLanguage(item.configInfo.name[0], '子参数名'),
        value: item.value
      }))
      const title =
				record.operationType === 2
				  ? getLanguageStr('plant_detail141', '输入项')
				  : getLanguageStr('device254', '返回结果')
      this.$refs.paramResult.show({
        list,
        title,
        terminal: this.terminal
      })
    },
    moreInput (record) {
      if (!record.extendWeb) return
      let recordCopy = _.cloneDeep(record)
      recordCopy.extendWeb = JSON.parse(recordCopy.extendWeb)

      let group = recordCopy.groupCode.split(',')
      let cmdMaps = deviceConfigOption.rule.optionClass[group[0]].filter(
        item => {
          return group[1].split('_')[1] == item.code
        }
      )
      let cmdList = cmdMaps[0].cmdList
      // let cmdMapres = cmdMaps[0].cmdMap;
      let inputArr = []
      // console.log(record.extendWeb)
      // console.log(record.extendWeb.inputParam)
      for (let i in cmdList) {
        if (
          recordCopy.extendWeb.inputParam[cmdList[i].code] !=
						undefined &&
					!cmdList[i].token
        ) {
          // 抽出用到的
          inputArr.push(cmdList[i])
        }
      }

      let Html = ''
      inputArr.forEach(item => {
        if (item.name && item.name.length) {
          let name = getLanguage(item.name[0], item.name[1])
          let unit = ''
          let value = ''
          if (item.type === 'input') {
            unit = item.unit
              ? getLanguage(item.unit[0], item.unit[1])
              : ''
            value = recordCopy.extendWeb.inputParam[item.code].v
          } else if (item.type === 'time') {
            unit = ''
            value =
							recordCopy.extendWeb.inputParam[
							  item.code
							].v.substring(0, 4) +
							'/' +
							recordCopy.extendWeb.inputParam[item.code].v
							  .toString()
							  .substring(4, 6) +
							'/' +
							recordCopy.extendWeb.inputParam[
							  item.code
							].v.substring(6, 8) +
							' ' +
							recordCopy.extendWeb.inputParam[
							  item.code
							].v.substring(8, 10) +
							':' +
							recordCopy.extendWeb.inputParam[
							  item.code
							].v.substring(10, 12) +
							':' +
							recordCopy.extendWeb.inputParam[
							  item.code
							].v.substring(12, 14)
          } else if (item.type === 'hm') {
            const hmResult =
							recordCopy.extendWeb.inputParam[item.code].v
            value =
							hmResult.substring(0, 2) +
							':' +
							hmResult.substring(2, 4)
          } else if (item.type === 'md') {
            const mdResult =
							recordCopy.extendWeb.inputParam[item.code].v
            value =
							mdResult.substring(0, 2) +
							'-' +
							mdResult.substring(2, 4)
          } else if (item.type === 'checkbox') {
            const checkboxResult = recordCopy.extendWeb.inputParam[
              item.code
            ].v.split('')
            let htmlTel = ''
            checkboxResult.forEach((e, i) => {
              htmlTel += `<span class="mr1x"> ${getLanguage(
                item.cmdList[i].text[0],
                '选项名'
              )} </span><span>${getLanguage(
                e === item.cmdList[i].valMap.on.val
                  ? item.cmdList[i].valMap.on.text[0]
                  : item.cmdList[i].valMap.off.text[0],
                '选项值'
              )}</span>${
                i === checkboxResult.length ? '' : '<br />'
              }`
            })
            value = `<div class="dpIB">${htmlTel}</div>`
          } else {
            item.list.forEach(items => {
              if (
                items.value ===
								recordCopy.extendWeb.inputParam[item.code].v
              ) {
                value = getLanguage(
                  items.text[0],
                  items.text[1]
                )
              }
            })
          }
          Html += `<div class='mb1x vaT_E'><span>${name}</span>:<span class='ml1x'>${value}${unit}</span></div>`
        }
      })
      if (this.terminal === 0) {
        this.$notify(`<div class='cContent'>${Html}</div>`, {
          title:
						record.operationType == 4
						  ? getLanguageStr('device254', '返回结果')
						  : getLanguageStr('device328', '指令内容')
        })
      } else {
        Dialog.alert({
          title:
						record.operationType == 4
						  ? getLanguageStr('device254', '返回结果')
						  : getLanguageStr('device328', '指令内容'),
          message: Html,
          allowHtml: true,
          confirmButtonText: getLanguageStr('device220', '我知道了'),
          confirmButtonColor: '#2F72FA',
          className: ' custDa',
          confirm: () => {
            Dialog.close()
          }
        })
      }
    },
    // 1成功
    moreResult (record) {
      let inputArr = []
      // console.log(record.extendWeb)
      if (!record.analysisResult) return
      let recordCopy = _.cloneDeep(record)
      recordCopy.analysisResult = JSON.parse(recordCopy.analysisResult)
      recordCopy.extendWeb = JSON.parse(recordCopy.extendWeb)

      let group = recordCopy.groupCode.split(',')
      let cmdMaps = deviceConfigOption.rule.optionClass[group[0]].filter(
        item => {
          return group[1].split('_')[1] == item.code
        }
      )
      let cmdList = cmdMaps[0].cmdList
      // let cmdMapres = cmdMaps[0].cmdMap;
      // console.log(record.extendWeb.inputParam)
      if (record.operationType == 5) {
        for (let i in cmdList) {
          if (
            recordCopy.extendWeb.inputParam[cmdList[i].code] !=
							undefined &&
						!cmdList[i].token
          ) {
            inputArr.push(cmdList[i])
          }
        }
      } else {
        for (let i in cmdList) {
          if (
            recordCopy.analysisResult[cmdList[i].code] !=
							undefined &&
						!cmdList[i].token
          ) {
            inputArr.push(cmdList[i])
          }
        }
      }

      // for(let i in recordCopy.extendWeb.inputParam){
      //  inputArr.push(i);
      // }
      let Html = ''
      let wrapHtml = ''
      inputArr.forEach(item => {
        if (!item) return
        if (item.name && item.name.length) {
          let name = getLanguage(item.name[0], item.name[1])
          let unit = ''
          let value = ''
          if (record.operationType == 4) {
            if (item.type === 'input') {
              unit = item.unit
                ? getLanguage(item.unit[0], item.unit[1])
                : ''
              value =
								(item.prefix ? item.prefix[0] : '') +
								recordCopy.analysisResult[item.code]
            } else if (item.type === 'time') {
              unit = ''
              value =
								recordCopy.analysisResult[item.code].substring(
								  0,
								  4
								) +
								'/' +
								recordCopy.analysisResult[item.code]
								  .toString()
								  .substring(4, 6) +
								'/' +
								recordCopy.analysisResult[item.code].substring(
								  6,
								  8
								) +
								' ' +
								recordCopy.analysisResult[item.code].substring(
								  8,
								  10
								) +
								':' +
								recordCopy.analysisResult[item.code].substring(
								  10,
								  12
								) +
								':' +
								recordCopy.analysisResult[item.code].substring(
								  12,
								  14
								)
            } else if (item.type === 'hm') {
              const hmResult =
								recordCopy.analysisResult[item.code]
              value =
								hmResult.substring(0, 2) +
								':' +
								hmResult.substring(2, 4)
            } else if (item.type === 'md') {
              const mdResult =
								recordCopy.analysisResult[item.code]
              value =
								mdResult.substring(0, 2) +
								'-' +
								mdResult.substring(2, 4)
            } else if (item.type === 'checkbox') {
              const checkboxResult = recordCopy.analysisResult[
                item.code
              ].split('')
              let htmlTel = ''
              checkboxResult.forEach((e, i) => {
                htmlTel += `<span class="mr1x"> ${getLanguage(
                  item.cmdList[i].text[0],
                  '选项名'
                )} </span><span>${getLanguage(
                  e === item.cmdList[i].valMap.on.val
                    ? item.cmdList[i].valMap.on.text[0]
                    : item.cmdList[i].valMap.off.text[0],
                  '选项值'
                )}</span>${
                  i === checkboxResult.length ? '' : '<br />'
                }`
              })
              value = `<div class="dpIB">${htmlTel}</div>`
            } else {
              item.list.forEach(items => {
                if (
                  items.value ===
									recordCopy.analysisResult[item.code]
                ) {
                  value = getLanguage(
                    items.text[0],
                    items.text[1]
                  )
                }
              })
            }
          } else {
            let Jsonp = recordCopy.analysisResult
            value = Jsonp[item.code]
              ? getLanguageStr('plant_detail168', '已成功')
              : getLanguageStr('plant_detail169', '已失败')
          }

          Html += `<div class='mb1x vaT_E' ><span>${name}</span>:<span class='ml1x'>${value}${unit}</span></div>`
          wrapHtml = `<div id='batchparamalter' class="" scroll>${Html}</div>`
        }
      })
      if (this.terminal === 0) {
        this.$notify(`<div class='cContent'>${wrapHtml}</div>`, {
          title: getLanguageStr('device254', '返回结果')
        })
      } else {
        Dialog.alert({
          title: getLanguageStr('device254', '返回结果'),
          message: wrapHtml,
          allowHtml: true,
          confirmButtonText: getLanguageStr('device220', '我知道了'),
          confirmButtonColor: '#2F72FA',
          className: ' custDa',
          confirm: () => {
            Dialog.close()
          }
        })
      }
    },
    show () {
      orderConfig.loadContralOption(this._getList)
      // if(window.deviceConfigOption){
      // 	this._getList();
      // }
      // else{
      // 	orderApi.apiGetDeviceConfigOption().then(success=>{
      // 		this._getList();
      // 	});
      // }
      lib.fillHeight()
      lib.setScroll($(this.$el).find('#readerRecordList [scroll]'))
    },
    order (orderBy) {
      this.orderProperty = orderBy
      if (this.orderDirection === 2) {
        this.orderedsc = 'ASC'
        this.orderDirection = 1
      } else {
        this.orderedsc = 'DESC'
        this.orderDirection = 2
      }
      this._getList()
    },
    instructionsStatusSelect (index) {
      this.instructionsStatusSelected = this.instructionsStatusList[
        index
      ].value
      this._getList()
    },
    getOrderName: function (data) {
      // 解析指令名称
      if (data.operationType == 3) return '--'
      return orderConfig.analyFunction(data).orderName
    },
    analysisExt (item) {
      // 入参
      switch (
        item.operationType // 1:读取指令，2设置指令，3:自定义，4:批量读取，5:批量设置
      ) {
        case 1: // 读取
          return '--'
          break
        case 2:
          let result = orderConfig.analyFunction(item) || {}
          return result.value
          break
        case 3: // 自定义指令
          return orderConfig.analyFunction(item).orderName
          break
        case 4: // 读取
          return '--'
          break
        default:
          return orderConfig.analyFunction(item)
          break
      }
    },
    analysisResult (item) {
      // 返回结果
      let result = orderConfig.analyFunction(item) || {}
      if (item.operationType == 1 || item.operationType == 3) {
        // 读取
        return result.value
      } else {
        return '--'
      }
    },
    _getList () {
      return new Promise(resolve => {
        if (this.terminal === 0) {
          this.$refs.loading.show()
        } else {
        }

        let queryParam = {
          deviceId: this.deviceId,
          deviceSn: this.deviceSn,
          // deviceType: this.deviceType,	// 2:普通设备
          // operationType: 12,	// 12:读取或设置
          orderType: 1, // 1:控制指令,2:升级指令
          ascDesc: this.orderDirection,
          orderBy: this.orderProperty,
          status: this.instructionsStatusSelected,
          page: this.pagination.request.page,
          size: this.pagination.request.size
        }
        orderApi.readRecordList(queryParam).then(
          res => {
            if (this.terminal === 0) {
              this.$refs.loading.hide()
            } else {
            }

            res.data.map(item => {
              // item.updateTime = Number(item.updateTime) + mz.tz(this.timeZone)._offset * 60 * 1000
              // 指令名称
              if (item.groupCode) {
                let codeInfo = item.groupCode.split(',')
                item.orderName = orderConfig.getOrderName(
                  codeInfo[1],
                  codeInfo[0]
                )
              } else {
                // 自定义指令
                item.orderName = ['--']
              }
              // 指令类型
              if (
                item.operationType == 1 ||
								item.operationType == 4
              ) {
                item.operationTypeName = getLanguageStr(
                  'word632',
                  '读取'
                )
              } else if (
                item.operationType == 2 ||
								item.operationType == 5
              ) {
                item.operationTypeName = getLanguageStr(
                  'cmd16',
                  '设置'
                )
              } else if (item.operationType == 3) {
                item.operationTypeName = getLanguageStr(
                  'word639',
                  '自定义'
                )
              }
              return item
            })

            if (
              this.terminal === 0 ||
							this.pagination.request.page === 1
            ) {
              this.list = res.data
            } else {
              this.list.push(...res.data)
            }
            let { total } = res
            this.pagination = { ...this.pagination, total }
            if (this.terminal === 0) {
              this.$refs.loading.hide()
            } else {
            }

            this.$nextTick(() => {
              resolve()
              lib.fillHeight()
              lib.setScroll(
                $(this.$el).find('#readerRecordList [scroll]')
              )
            })
          },
          () => {
            this.$refs.loading.hide()
          }
        )
      })
    }
  },
  created () {
    this.terminal = stage.browser.mobile ? 1 : 0
    if (this.terminal === 1) {
      this.pagination = {
        request: {}
      }
      this.pagination.request.page = 0
      this.pagination.request.size = 20
    }
  },
  mounted () {
    this.instructionsStatusList = this.instructionsStatusList.map(item => {
      if (item.value == 0) {
        return { ...item, statistic: { a: '', b: '' } }
      } else if (item.value == 100) {
        return { ...item, statistic: { a: 'A68', b: 'A6830' } }
      } else if (item.value == 300) {
        return { ...item, statistic: { a: '', b: 'A6833' } }
      } else if (item.value == 400) {
        return { ...item, statistic: { a: '', b: '' } }
      } else if (item.value == 500) {
        return { ...item, statistic: { a: 'A68', b: 'A6832' } }
      } else if (item.value == 666) {
        return { ...item, statistic: { a: 'A68', b: 'A6831' } }
      } else {
        return item
      }
    })
    // console.log(this.instructionsStatusList)
  }
}
</script>
<style lang="scss" scoped>
.redO {
	color: rgba(61, 197, 165, 1);
	background-color: rgba(61, 197, 165, 0.15);
	border-top-left-radius: 2.666vmin;
	border-bottom-right-radius: 2.666vmin;
}
.setO {
	color: rgba(255, 180, 80, 1);
	background-color: rgba(255, 180, 80, 0.15);
	border-top-left-radius: 2.666vmin;
	border-bottom-right-radius: 2.666vmin;
}
.custO {
	color: rgba(47, 114, 250, 1);
	background-color: rgba(47, 114, 250, 0.15);
	border-top-left-radius: 2.666vmin;
	border-bottom-right-radius: 2.666vmin;
}
.typenameOrder {
	min-width: 2vmin;
}
.nodate {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
}
.mb8xM {
	padding-bottom: 3.45vmin;
	margin-bottom: 3.2vmin;
}
.ft15 {
	font-size: 4vmin;
}
.userSelect {
	user-select: text;
	-webkit-user-select: text;
}
.mb1x5 {
	margin-bottom: 2.66vmin;
}
.mb2x5 {
	margin-bottom: 5.32vmin;
}
.pb2x5 {
	padding-bottom: 5.32vmin;
}
.pt1x5 {
	padding-top: 2.66vmin;
}
.mobile {
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
.pt05xx {
	padding-top: 1vmin;
}
.pb05xx {
	padding-bottom: 1vmin;
}
.ml2xx {
	margin-left: 1.07vmin;
}
</style>
<style lang="scss">
.custDa {
	.van-dialog__header {
		padding-left: 5.33vmin;
		text-align: left;
	}
	.van-dialog__content {
		padding-left: 5.33vmin;
		text-align: left;
	}
	.van-dialog__message {
		padding-left: 0;
		text-align: left;
	}
	span {
		font-size: 4vmin;
	}
}
.noDataList {
	.van-list__finished-text {
		display: none;
	}
}
.mobile > div {
	transform-style: preserve-3d;
}
.titleRecord {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	span {
		// display: block;
		vertical-align: middle;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/ReaderRecord.vue